module.exports = __webpack_public_path__ + "static/livestreaming-5-7e175aae108e4a7bf9a2a96ab0dcf800.png";